'use strict';

(function () {
  'use strict';

  angular.module('msGoals').controller('EditGoalsListCtrl', EditGoalsListCtrl);

  EditGoalsListCtrl.$inject = ['goalsList', 'close', 'goalSvc'];

  function EditGoalsListCtrl(goalsList, close, goalSvc) {
    var vm = this;
    vm.deleteConfirm = deleteConfirm;
    vm.closeModal = closeModal;

    activate();

    ////////////////

    function activate() {
      vm.title = 'EditGoalsListCtrl';
      vm.goalsList = goalsList;
    }

    function deleteConfirm(goal) {
      goal.status = 'DELETED';
      goalSvc.saveGoal(goal).then(function () {
        goalsList.splice(_.findIndex(goalsList, function (g) {
          return g.id === goal.id;
        }), 1);
      });
    }

    function closeModal() {
      // 200ms pause to let ngAnimate hide the modal.
      close(false, 200);
    }
  }
})();